import React, { useState, useEffect } from "react";
import NotificationService from "services/NotificationService";
import classNames from "classnames";
import UserNotificationsList from "components/UserNotificationsList";
import { ReactComponent as BellIcon } from "assets/img/icons/bell_h.svg";
import { useParams } from "react-router-dom";
import { NotificationsContext } from "store/contexts/notificationContext";
import { CSSTransition } from "react-transition-group";
import { useGlobalContext } from "store/contexts/globalContext";

export default ({
  team,
  newNotification,
  newNotificationData,
  setNewNotification,
}) => {
  const { teamId } = useParams();
  const { microsoftConfigureTab } = useGlobalContext();
  const [notificationTotal, setNotificationTotal] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [notificationPage, setNotificationPage] = useState(1);
  const [myTeamId, setTeamId] = useState(teamId ?? null);
  const [notificationOpen, setNotificationOpen] = useState(false);

  useEffect(() => {
    if (!microsoftConfigureTab || teamId !== "general") {
      return;
    }

    setTeamId(team?.id);

    return () => {
      setNotifications([]);
      setNotificationTotal("");
    };

    //eslint-disable-next-line
  }, [team, microsoftConfigureTab]);

  useEffect(() => {
    if (!newNotificationData) {
      return;
    }
    createNotification(newNotificationData);

    //eslint-disable-next-line
  }, [newNotificationData]);

  const closeNotificationBar = () => {
    setNotificationOpen(false);
    setNewNotification(false);
  };

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      try {
        const response = await NotificationService.getAllNotifications(
          myTeamId,
          notificationPage
        );

        setNotifications(
          Array.from(new Set([...notifications, ...response.data.data]))
        );

        setNotificationTotal(response?.data?.meta?.total);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    })();
    //eslint-disable-next-line
  }, [notificationPage, myTeamId]);

  const handleNotification = () => {
    setNotificationOpen(true);
  };

  const getNextNotificationPageData = () => {
    setIsLoading(true);
    setNotificationPage(notificationPage + 1);
  };

  const createNotification = (notificaton) => {
    if (!notificaton) {
      return;
    }

    const notificationCopy = { ...notificaton };

    setNotifications(Array.from(new Set([notificationCopy, ...notifications])));

    incrementTotal();
  };

  const incrementTotal = () => {
    setNotificationTotal(notificationTotal + 1);
  };

  const readNotification = (notification) => {
    const notificatonCopy = [...notifications];

    notificatonCopy[
      notificatonCopy.findIndex((tNotification) => {
        return tNotification.id === notification.id;
      })
    ] = {
      ...notification,
    };

    setNotifications(notificatonCopy);
  };

  return (
    <>
      <p
        onClick={handleNotification}
        className={classNames({
          "notifications_icon collapsed": true,
          //eslint-disable-next-line
          [" " + "active"]: notificationOpen && true,
          newNotificationIcon:
            (newNotification && notificationOpen === false) ||
            notifications.some((notification) => notification.read_at === false)
              ? true
              : false,
        })}
      >
        <BellIcon className="rightHeaderNotificationIcon" />
      </p>
      <CSSTransition
        in={notificationOpen}
        timeout={300}
        unmountOnExit
        classNames="dropdown-element"
      >
        <NotificationsContext.Provider
          value={{
            readNotification,
            closeNotificationBar,
          }}
        >
          <UserNotificationsList
            closeNotificationBar={closeNotificationBar}
            isLoading={isLoading}
            notifications={notifications}
            getNextNotificationPageData={getNextNotificationPageData}
            notificationTotal={notificationTotal}
          />
        </NotificationsContext.Provider>
      </CSSTransition>
    </>
  );
};
